<template>
  <div class="main-content" v-if="access_token">
    <div>
      <div class="wrap-content container" id="container">
        <!-- start: DASHBOARD TITLE -->
        <section id="page-title" class="padding-top-15 padding-bottom-15">
          <div class="row">
            <div class="col-sm-7">
              <h1 class="mainTitle">Dashboard</h1>
              <span class="mainDescription" v-if="access_token">Hello, {{ userName }} </span>
              <!-- <h1 v-if="access_token">Hello, {{ userName }}</h1> -->
              <h3 v-if="!access_token">not logged in</h3>
            </div>

          </div>
        </section>
        <!-- end: DASHBOARD TITLE -->
        <!-- start: FEATURED BOX LINKS -->
        <div class="container-fluid container-fullw bg-white">
          <div class="row">
            <div class="col-sm-4">
              <div class=" no-radius text-center">

              </div>
            </div>

            <div class="col-sm-12">
              <div class=" no-radius text-center">
                <div class="panel-body">
                  <div class="thread-image">
                    <img :src="`/assets/images/undraw_medicine_b-1-ol 1.png`" alt="User Avatar" class="img-fluid" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end: FEATURED BOX LINKS -->

      </div>
    </div>
  </div>

</template>
<script>
import { store } from '@/Store';
export default {
  name: "HomeView",
  components: {},
  // props: ["orders"],

  date() {
    return {
      userName: "",
      access_token: null,

      appUrl: "" // or from environment variables
    };
  },
  mounted() {
    // if (window.Main) {
    //   window.Main.init();
    // }
    // if (window.Index) {
    //   window.Index.init();
    // }
  },
  async beforeCreate() {
    this.access_token = localStorage.getItem("access_token");
    this.userName = store.user ? store.user.name : 'User'; // Fallback to "User" if not found
    // this.appUrl = "https://backend.allo-doctor.com" // or from environment variables
    // this.appUrl = 'http://localhost:8080' // or from environment variables
  }
};
</script>
